import { render, staticRenderFns } from "./StaffListsReportExcel.vue?vue&type=template&id=b2fdbdca&scoped=true"
import script from "./StaffListsReportExcel.vue?vue&type=script&lang=js"
export * from "./StaffListsReportExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fdbdca",
  null
  
)

export default component.exports